import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import IndexPage from './pages/IndexPage';
import ServicePage from './pages/ServicePage';
import PhilosophyPage from './pages/PhilosophyPage';
import PartnerPage from './pages/PartnerPage';
import ContactPage from './pages/ContactPage';
import DownloadPage from './pages/DownloadPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AcademyDetailLP from './pages/lp/academy/AcademyDetailLP';
import AcademyContactPage from './pages/lp/academy/AcademyContactPage';
import SeminarLP from './pages/lp/academy/SeminarLP';
import CancellationPolicyPage from './pages/lp/academy/CancellationPolicyPage';
import BookingPage from './pages/lp/academy/BookingPage';
import AcademyMembersPage from './pages/lp/academy/AcademyMembersPage';
import AdminDashboard from './pages/admin/AdminDashboard';

// ページ遷移時に自動的にトップにスクロールするコンポーネント
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash.replace('#', ''));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

// HP用レイアウトでラップされたルート
function HPRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/service" element={<ServicePage />} />
        <Route path="/philosophy" element={<PhilosophyPage />} />
        <Route path="/partner" element={<PartnerPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        {/* 404ページ */}
        <Route path="*" element={
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-brown mb-4">404</h1>
              <p className="text-gray-text mb-4">ページが見つかりません</p>
              <a href="/" className="bg-pink-beige text-brown px-6 py-3 rounded-md hover:bg-opacity-90 transition-colors duration-200">
                トップページに戻る
              </a>
            </div>
          </div>
        } />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <Router basename="/">
      <ScrollToTop />
      <Routes>
        {/* LPページ（独自レイアウト） */}
        <Route path="/lp/academy" element={<AcademyDetailLP />} />
        <Route path="/lp/academy/detail" element={<AcademyDetailLP />} />
        <Route path="/lp/academy/seminar" element={<SeminarLP />} />
        <Route path="/lp/academy/contact" element={<AcademyContactPage />} />
        <Route path="/lp/academy/cancellation-policy" element={<CancellationPolicyPage />} />
        <Route path="/lp/academy/booking" element={<BookingPage />} />
        <Route path="/academy/members" element={<AcademyMembersPage />} />
        {/* 管理画面（/admin配下は全てここで拾う。末尾スラッシュ・下位パスも公開サイトの404に落とさずログイン画面へ） */}
        <Route path="/admin/*" element={<AdminDashboard />} />
        {/* HPページ（HP用レイアウト） */}
        <Route path="/*" element={<HPRoutes />} />
      </Routes>
    </Router>
  );
}

export default App;
